<full-screen-loading *ngIf="assetsMainConfigs?.isUploading" [text]="'Uploading asset...'"></full-screen-loading>
<div>
    <div class="dashboard-page padded hide-overflow">
        <!-- Back button (sub-views only) -->
        <div class="sub-view-header" *ngIf="toDisplayBackButton">
            <button mat-icon-button (click)="navigateButtonClicked(returnButton)" class="back-button">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h2>{{ assetTypeDisplay === AssetType.VIDEO ? 'Video Library' : 'Assets Library' }}</h2>
        </div>

        <!-- ═══ HERO ═══ -->
        <div
            class="hero"
            *ngIf="toDisplayNavigationButtons && toDisplayHeader && !toDisplayBackButton"
            [class.hero--dragover]="isDraggingOverUpload"
            (dragenter)="onDragEnter($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="handleFileDrop($event)">
            <div class="hero__bg"></div>
            <div class="hero__glow"></div>

            <div class="hero__drop-overlay" *ngIf="isDraggingOverUpload">
                <mat-icon class="hero__drop-icon">cloud_upload</mat-icon>
                <span class="hero__drop-text">Drop assets to upload</span>
            </div>

            <div class="hero__top">
                <div class="hero__text">
                    <h1 class="hero__title">
                        Manage &amp; create
                        <span class="hero__title--accent">your assets</span>
                    </h1>
                    <p class="hero__subtitle">
                        Upload, browse stock libraries, or generate stunning images and videos with AI — all in one
                        place.
                    </p>
                </div>
                <input #fileInput type="file" multiple [accept]="acceptAttr" (change)="onFileSelect($event)" hidden />
            </div>

            <div class="hero__features" *ngIf="toDisplayButtons">
                <button *ngIf="toMakeUploadAsMainButton" class="feature feature--primary" (click)="fileInput.click()">
                    <mat-icon class="feature__icon">cloud_upload</mat-icon>
                    <span class="feature__label">Upload assets</span>
                </button>
                <ng-container *ngFor="let button of buttons">
                    <button
                        *ngIf="button.display"
                        class="feature"
                        [class.feature--disabled]="button.disabled"
                        [disabled]="button.disabled"
                        (click)="navigateButtonClicked(button)">
                        <mat-icon class="feature__icon">{{ button.icon }}</mat-icon>
                        <span class="feature__label">{{ button.text }}</span>
                        <mat-icon *ngIf="button.disabled" class="feature__lock">lock</mat-icon>
                    </button>
                </ng-container>
            </div>
        </div>

        <!--<div class="loader" *ngIf="isLoadingImageSwap">Loading swap...</div>-->

        <ng-container [ngSwitch]="activeComponentId">
            <!-- Photo Library -->
            <ng-container *ngSwitchCase="this.components.photoLibrary">
                <app-photos-list
                    [isLoading]="isLoadingImageSwap"
                    [itemsPerPage]="5"
                    [photoService]="this.assetsMainConfigs.photoService"
                    [initialPrompt]="assetsMainConfigs.initialGenerateImagePrompt"
                    (newPhotoSelected)="onPhotoSelectedFromPhotoList($event)">
                </app-photos-list>
                <!--        <div class="loader" *ngIf="isLoadingImageSwap">LOADING...</div>-->
            </ng-container>
            <ng-container *ngSwitchCase="this.components.videoLibrary">
                <app-photos-list
                    [isLoading]="isLoadingImageSwap"
                    [itemsPerPage]="5"
                    [photoService]="this.assetsMainConfigs.photoService"
                    [initialPrompt]="assetsMainConfigs.initialGenerateImagePrompt"
                    (newPhotoSelected)="onPhotoSelectedFromPhotoList($event)">
                </app-photos-list>
                <!--        <div class="loader" *ngIf="isLoadingImageSwap">LOADING...</div>-->
            </ng-container>

            <!-- Generate Image -->
            <ng-container *ngSwitchCase="this.components.generateImage">
                <div>
                    <app-generate-asset-section
                        [assetType]="'image'"
                        [isGenerating]="isLoadingAssetGenerate"
                        [generatedAssetData]="this.generatedVideoSocketData"
                        [generatedImageUrl]="generatedImageSource"
                        (generateImage)="generateAsset($event)"
                        (generateVideo)="generateVideoAsync($event)"
                        (useGeneratedAsset)="useGeneratedImageAsync($event)"
                        (editImage)="editImageAsync($event)"
                        (resetAssetData)="resetAssetData()"
                        [showUseButton]="toDisplayUseMeInImageGenerating"
                        [enableEditImage]="this.enableToEditImage"
                        [enableImageToVideo]="this.enableImageToVideo">
                    </app-generate-asset-section>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="this.components.generateVideo">
                <div>
                    <app-generate-asset-section
                        [assetType]="'video'"
                        [isGenerating]="isLoadingAssetGenerate"
                        [generatedAssetData]="this.generatedVideoSocketData"
                        [generatedImageUrl]="generatedImageSource"
                        (generateVideo)="generateVideoAsync($event)"
                        (useGeneratedAsset)="useGeneratedVideoAsync($event)"
                        (resetAssetData)="resetAssetData()"
                        [showUseButton]="this.toDisplayUseMeInVideoGenerating"
                        [enableEditImage]="this.enableToEditImage"
                        [enableImageToVideo]="this.enableImageToVideo">
                    </app-generate-asset-section>
                </div>
            </ng-container>

            <!-- File Drop -->
            <ng-container *ngSwitchCase="this.components.fileDrop">
                <h2>Upload Asset</h2>
                <p>Upload your own images to use in your project</p>
                <div class="upload-box">
                    <app-file-drop
                        appUploaderProgress
                        [uploadingService]="assetsMainConfigs"
                        [accepts]="
                            this.assetTypeDisplay === AssetType.VIDEO
                                ? ['.mp4']
                                : ['.svg', '.png', '.jpeg', '.jpg', '.gif', '.pdf']
                        "
                        [hideUpload]="true"
                        [uploadAPI]="null"
                        (filedropped)="onFileDrop($event)"
                        [toUploadWhenDropped]="false">
                    </app-file-drop>
                    <!--            <div class="no-image-selected" *ngIf="!takeDynamicLottieContext">-->
                    <!--                Please select an image to switch first--
 </div>-->
                    <div class="loading" *ngIf="isUploadingImage">Loading upload...</div>
                </div>
            </ng-container>

            <!-- Assets -->
            <ng-container *ngSwitchCase="this.components.myAssets">
                <app-assets
                    [projectId]="projectId"
                    [hosted]="this.isHosted"
                    [toDisplayLoading]="this.toDisplayLoading"
                    [toShowSelectAsset]="this.toDisplaySelectAsset"
                    [toDisplayFileDrop]="false"
                    [filterAssetBy]="assetTypeDisplay"
                    [selectAsset]="this.selectAssetImmediate"
                    (selectedUrl)="selectMyAsset($event)"
                    (updateComponent)="this.updateComponent($event)"
                    (extendVideoEventEmitter)="this.extendVideoAsync($event)"
                    [enableEditImage]="this.enableToEditImage"
                    [enableImageToVideo]="this.enableImageToVideo"></app-assets>
            </ng-container>
        </ng-container>
        <div class="exit-button small-icon-button" *ngIf="this.toDisplayExitButton">
            <button mat-icon-button (click)="exitButtonClicked()" class="drawer-back-button">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>
